import React, { useEffect, useState } from "react";
import { Box, Button, Chip, Stack, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { GlobalState } from "context/GlobalContext";
import { pythonVmInstance } from "utils/AxiosInstances/RareboxPythonInstance";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import DownloadIcon from '@mui/icons-material/Download';
import FileSaver from "file-saver";
import { AuthState } from "context/AuthContext";
import { SbtRoleAccess } from "data/storeBudgetData";


const formatCurrency = (value) => `Rs. ${Number(value || 0).toLocaleString("en-IN")}`;
const formatDate = (value) => (value ? String(value).split("T")[0] : "-");



export default function ListStoreBudget() {
  const [budgetList, setBudgetList] = useState([]);
  const { setSnackBar, snackBar, setSnackBarOpen, setLoadingOpen } = GlobalState();
  const navigate = useNavigate();
  const { user } = AuthState();

  const roleData = SbtRoleAccess(user)

  const handleDownload = async (e, row) => {
    e.stopPropagation();
    try {
          // setDownloading(true);
          setLoadingOpen(true);
          await pythonVmInstance({
            url: `/store-budget-tracker/report/download-store-budget?project_id=${row?.project_id}`,
            headers: {
              "Content-Type": "application/json",
            },
            method: "GET",
            responseType: "blob",
          }).then((res) => {
            const url = URL.createObjectURL(res.data);
            FileSaver.saveAs(url, `${row?.project_id}_store_budget.csv`);
          });
        } catch (error) {
          setSnackBarOpen(true);

          setSnackBar({
            ...snackBar,
            message: "Failed to download file",
            severity: "error",
            anchorOrigin: { horizontal: "center", vertical: "top" },
          });
        }finally {
      setLoadingOpen(false);
    }
  }

  const columns = [
  { field: "project_id", headerName: "Project Id", minWidth: 180, flex: 1.2 },
  { field: "store_name", headerName: "Store Name", minWidth: 180, flex: 1.2 },
  { field: "store_code", headerName: "Store Code", minWidth: 120, flex: 0.9 },
  { field: "channel", headerName: "Channel", minWidth: 120, flex: 0.9 },
  { field: "project", headerName: "Project", minWidth: 140, flex: 1 },
  { field: "city", headerName: "City", minWidth: 120, flex: 0.9 },
  { field: "state", headerName: "State", minWidth: 120, flex: 0.9 },
  { field: "carpet_area", headerName: "Carpet Area (sq ft)", minWidth: 150, flex: 1 },
  { field: "std_per_sq_feet", headerName: "STD (sq ft)", minWidth: 150, flex: 1 },
  {
    field: "total_budget",
    headerName: "Total Budget",
    minWidth: 150,
    flex: 1,
    renderCell: ({ row }) => formatCurrency(row?.total_budget),
  },
  {
    field: "is_submitted",
    headerName: "Status",
    minWidth: 110,
    flex: 0.8,
    renderCell: ({ row }) => {
        let submitted = row?.status === "submitted";
     return ( <Chip
        label={submitted  ? "Closed" : "Open"}
        color={submitted ? "success" : "warning"}
        size="small"
        variant="outlined"
      />)
    },
  },
  {
    field: "action",
    headerName: "Action",
    minWidth: 150,
    flex: 1,
    renderCell: (params) => (<DownloadIcon onClick = {(e)=> handleDownload(e, params?.row)} />),
  },
//   { field: "created_at", headerName: "Created At", minWidth: 130, flex: 1, renderCell: ({ row }) => formatDate(row?.created_at) },
].map((col) => ({ headerAlign: "center", align: "center", sortable: false, ...col }));

  const handleCreateBudgetClick = () => {

			navigate(`/explore/store_budget_tracker/create_store_budget`)
    	}
  
      const handleRowClick = (row) => {
    navigate(`/explore/store_budget_tracker/create_store_budget`, {
      state: { data: row },
    });
  };


  const fetchBudgets = async () => {
    try {
      setLoadingOpen(true);
      const res = await pythonVmInstance({
        url: `/store-budget-tracker/store-budget`,
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });
      setBudgetList(
        (res?.data || []).map((row, i) => ({ ...row, id: row?.id || `budget-${i}` }))
      );
    } catch {
      setSnackBarOpen(true);
      setSnackBar({
        ...snackBar,
        message: "Failed to fetch store budgets",
        severity: "error",
        anchorOrigin: { horizontal: "center", vertical: "top" },
      });
    } finally {
      setLoadingOpen(false);
    }
  };

  useEffect(() => {
    fetchBudgets();
  }, []);

  return (
    <Box padding={2}>
      <Stack direction="row" justifyContent="flex-end" alignItems="center" marginBottom={2}>
        <Button variant="contained" startIcon={<AddIcon />} onClick={handleCreateBudgetClick} disabled={roleData?.roles === "VIEWER"}>
          Create Store Budget
        </Button>
      </Stack>

      <Box boxShadow="0px 1px 3px rgba(0,0,0,0.2)" borderRadius={2} overflow="hidden">
        <DataGrid
          rows={budgetList}
          columns={columns}
          pageSizeOptions={[10, 25, 50]}
          initialState={{ pagination: { paginationModel: { pageSize: 10, page: 0 } } }}
          onRowClick={(params) => handleRowClick(params?.row)}
          sx={{
            "& .MuiDataGrid-columnHeader": {
              backgroundColor: "#dbeafe",
              fontWeight: 600,
              borderRight: "1px solid #bfdbfe",
            },
            "& .MuiDataGrid-cell": { borderColor: "#eceff1", cursor: "pointer" },
            "& .MuiDataGrid-footerContainer": { borderTop: "1px solid #eceff1" },
            "& .MuiDataGrid-virtualScroller": { minHeight: 320, maxHeight: 400 },
          }}
        />
      </Box>
    </Box>
  );
}
